import { render } from "./Paginator.vue?vue&type=template&id=ab7adb16&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"

import "./Paginator.vue?vue&type=style&index=0&id=ab7adb16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab7adb16"]])

export default __exports__